<script setup lang="ts">
interface Heading {
  name: string;
}
interface Props {
  headings: Heading[];
}

defineProps<Props>();
</script>

<template>
  <li class="list">
    <header class="list__header">
      <span v-for="heading in headings">{{ heading.name }}</span>
    </header>
  </li>
</template>

<style scoped lang="postcss">
li {
  header {
    @apply flex justify-between;
  }
}
</style>
